// TODO: find a new name. InlineQueryError? MutationError?
import { BoxProps } from "@chakra-ui/core";
import { P } from "atoms/typography";
import flatten from "flat";
import { AuthTokenError } from "lib/apollo/errors";
import { validationErrors } from "lib/apollo/helpers";
import useScrollOnMount from "lib/useScrollOnMount";

const messageForError = (error: any) => {
  if (error.networkError instanceof AuthTokenError) {
    return "Redirecting to login page...";
  }

  const gqlError = error?.graphQLErrors?.[0];
  if (gqlError) {
    if (gqlError.extensions && gqlError.extensions.code === "BAD_USER_INPUT") {
      return messageForValidationError(gqlError);
    }
  }

  // User-friendly string from Auth0
  if (error.description) {
    return error.description;
  }
};

const messageForValidationError = (apolloError) => {
  const errors = validationErrors(apolloError);
  if (errors) {
    const flattened = flatten(errors);
    const messages = Object.values(flattened).join(", ");
    return `${apolloError.message}: ${messages}`;
  }
  return apolloError.message;
};

type ErrorHandling = {
  error: any; // TODO.
};

export type QueryErrorProps = ErrorHandling & BoxProps;

// TODO: Error handling component
// TODO: Restyle this according to PDS 3.0
export const QueryError = ({ error, children, ...props }: QueryErrorProps) => {
  const ref = useScrollOnMount({ watch: error });

  return (
    <div ref={ref} data-cy="query-error">
      <P {...props}>{messageForError(error) || children}</P>
    </div>
  );
};
QueryError.defaultProps = {
  color: "white",
  bg: "pink.500",
  mb: 0,
  py: 3,
  px: 4,
  rounded: "lg",
  children: "Something went wrong! Please try again.",
};
